export default __webpack_public_path__ + "static/media/infestation.e97c3ff1.png";